import React, { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import config from '@config'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import useFeatureFlagsSkeleton from '@hooks/useFeatureFlagsSkeleton'
import useViewportType from '@hooks/useViewport/useViewportType'
import Popover from '@components/Popover'

import FmtOnboardingTooltipContent from './FmtOnboardingTooltipContent'

const {
  fmtOnboarding: { tooltipContentDesktopWidth, tooltipContentMobileWidth },
} = config

type FmtTooltipSportsPageProps = {
  setShouldShowTooltip: (shouldShow: boolean) => void
}

const StyledFmtTooltip = styled(Popover)<{
  left?: number
  position: 'top' | 'bottom'
}>`
  ${({
    theme: {
      colors: { fillSurface },
      spacing: { spacing8, spacing16, spacing20 },
    },
    position,
  }) => {
    return css`
      background-color: ${fillSurface};
      width: ${tooltipContentMobileWidth}px;
      border-radius: ${spacing8};
      ${desktopCSS(css`
        width: ${tooltipContentDesktopWidth}px;
      `)}

      ${position === 'bottom' &&
      css`
        top: ${spacing20};
        right: calc(50vw - ${tooltipContentMobileWidth}px / 2 - ${spacing16});

        ${tabletCSS(css`
          right: calc(50vw - ${tooltipContentDesktopWidth}px / 2 - 68px);
        `)}

        &:after {
          right: calc(${tooltipContentDesktopWidth}px / 2 - ${spacing16});
        }
      `}

      ${position === 'top' &&
      css`
        ${desktopCSS(css`
          right: calc(${tooltipContentDesktopWidth}px - ${spacing16});
          top: -136px;
          &:after {
            right: calc(${tooltipContentDesktopWidth}px / 2 - ${spacing8});
          }
        `)}
      `}
    `
  }}
`

const FmtTooltipSportsPage: FunctionComponent<FmtTooltipSportsPageProps> = ({
  setShouldShowTooltip,
}) => {
  const { isFollowMyTeamEnabled } = useFeatureFlagsSkeleton()
  const viewportType = useViewportType()
  const isDesktop = viewportType === 'desktop'

  return isFollowMyTeamEnabled ? (
    <StyledFmtTooltip position={isDesktop ? 'top' : 'bottom'}>
      <FmtOnboardingTooltipContent
        setShouldShowTooltip={setShouldShowTooltip}
      />
    </StyledFmtTooltip>
  ) : null
}

export default FmtTooltipSportsPage
